function Footer() {

    return (
        <>
            <footer id="footer" className="footer light-background">
                <div className="container">
                    <div className="copyright text-center ">
                        <p>
                            © <span>Copyright 2025</span>{" "}
                            <strong className="px-1 sitename">Jose Bravo-Tejeda</strong>
                            <span>
                All Rights Reserved
                <br />
              </span>
                        </p>
                    </div>
                    <div className="social-links d-flex justify-content-center">
                        <a href="https://x.com/bravaldi" target="_blank" rel="noreferrer"><i className="bi bi-twitter-x" /></a>
                        <a href="https://www.facebook.com/profile.php?id=61572849707175" target="_blank" rel="noreferrer"><i className="bi bi-facebook" /></a>
                        <a href="https://bsky.app/profile/bravaldi" target="_blank" rel="noreferrer"><i className="bi bi-bluesky" /></a>
                        <a href="https://www.linkedin.com/in/josebravotejeda" target="_blank" rel="noreferrer"><i className="bi bi-linkedin" /></a>
                    </div>
                    <div className="credits">
                        {/* All the links in the footer should remain intact. */}
                        {/* You can delete the links only if you've purchased the pro version. */}
                        {/* Licensing information: https://bootstrapmade.com/license/ */}
                        {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
                        Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;